import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as nextMonitoringReducer from "containers/Next/Monitoring/NextMonitoringReducer";

import MonitoringSummary from "components/Next/Monitoring/MonitoringSummary";

const getId = (props) =>
  props && props.id
    ? props.id
    : props && props.match && props.match.params && props.match.params.datasetId
      ? props.match.params.datasetId
      : "new";

class MonitoringSummaryContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <MonitoringSummary {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {};
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);

  return {
    id: id,
    monitoringSummary: nextMonitoringReducer.getMonitoringSummary(state, id)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MonitoringSummaryContainer);
